// extracted by mini-css-extract-plugin
module.exports = {"aside":"aside-2XIR61CP","ad":"ad-eJzwOrzB"};